<script>
import bikeStations from '../../data/bike-station-locations/index.json'
import { monthRefs } from '../common.js';
export let bgCssClass = 'bg-primary'
export let iconClass = 'fas fa-bicycle';
export let stationIdField = 'startstationid'
export let countfield = 'total'
export let bothStations = false
export let title = '-';
export let data = {};
export let currentType = 'all';
export let monthNo = 1;
export let topNo = 10;

$ : list2019 = (currentType === 'all') ? data.data2019.all : data.data2019.bymonth[monthNo]
$ : list2020 = (currentType === 'all') ? data.data2020.all : data.data2020.bymonth[monthNo]

function showAll () {
  currentType = 'all'
}
function updateMonth (no = 1) {
  monthNo = no
  currentType = 'month'
}
</script>

<section class="{`${bgCssClass} sectionx hero is-fullheight`}">
  <div class="hero-body">
    <div class="container">
        <div class="ioreveal animate__animated" data-anicss="animate__fadeInDown">
          <h2><i class="{iconClass}"></i> {title}</h2>
          <slot></slot>
          <div class="buttons" style="margin-top:15px">
            <button
              class:is-link="{currentType === 'all'}"
              class="button"
              on:click={() => showAll()}>All</button>

          {#each Array(8) as _, i}
            <button
              class:is-link="{currentType === 'month' && monthNo === (i+1)}"
              class="button"
              on:click={() => updateMonth(i+1)}>{monthRefs[i].abbr}</button>
          {/each}

          </div>

        </div>
        <div class="flex-parent" class:bothstations="{bothStations}">
          <div class="flex-child">
            <p class="text-2019">2019</p>
            <ul>
            {#each list2019.slice(0,topNo) as item}
              <li>
                <span class="text-2019">{Number(item[countfield]).toLocaleString()}</span>
              {#if bothStations}
                {(bikeStations[item.startstationid]) ? bikeStations[item.startstationid].title : '?'}
                <div class="to">to</div>
                {(bikeStations[item.endstationid]) ? bikeStations[item.endstationid].title : '?'}
              {:else}
                {(bikeStations[item[stationIdField]]) ? bikeStations[item[stationIdField]].title : '?'}
              {/if}
              </li>
            {/each}
            </ul>
          </div>
          <div class="flex-child">
            <p class="text-2020">2020</p>
            <ul>
            {#each list2020.slice(0,topNo) as item}
              <li>
                <span class="text-2020">{Number(item[countfield]).toLocaleString()}</span>
              {#if bothStations}
                {(bikeStations[item.startstationid]) ? bikeStations[item.startstationid].title : '?'}
                <div class="to">to</div>
                {(bikeStations[item.endstationid]) ? bikeStations[item.endstationid].title : '?'}
              {:else}
                {(bikeStations[item[stationIdField]]) ? bikeStations[item[stationIdField]].title : '?'}
              {/if}
              </li>
            {/each}
            </ul>
          </div>
        </div>

    </div>
  </div>
</section>

<style>
li {
  border-bottom: solid 1px rgba(255,255,255,0.2);
  margin-right: 20px;
  text-align: left;
}
.bothstations li {
  font-size: 1.2em;
}
.flex-child ul > li > span {
  font-size: 1rem;
  font-weight: 200;
  text-decoration: none;
}
.buttons .button {
  width: 75px;
  text-transform: uppercase;
}

.to {
  display: inline-block;
  color: #ccc;
  font-weight: 200;
  font-size: 1rem;
  font-style: italic;
}

@media (max-width: 640px) {
  li {
    font-size: 14px;
    margin-right: 10px;
  }
  .bothstations li {
    font-size: .9em;
  }
  .flex-child ul > li > span {
    display: block;
  }
  .to {
    font-size: .8rem;
  }

}
</style>